
import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { useTheme } from "../../contexts/ThemeContext";
import { useState } from "react";

function VerifyCertificate() {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);

  return (
    <>
      <Navbar />
      <div className="min-h-[80dvh] p-8">
        <div className="w-full h-[80px]"></div>

        {loading && (
          <div className="absolute inset-0 bg-transparent flex items-center justify-center z-10" style={{ transition: "background-color 0.1s ease", height: "90%" }}>
            <div
              className="size-16 border-[6px] border-gray-300 rounded-full animate-spin"
              style={{ borderTopColor: theme.mode === "light" ? theme.colors.button_light : theme.colors.button_dark }}
            ></div>
          </div>
        )}

        {/* Contenedor del iframe */}
        <div className="relative w-full h-[60vh] overflow-hidden">
          <iframe
            src="https://aulavirtual.linkcap.cl/mod/customcert/verify_certificate.php"
            title="Verificación de Certificado"
            className="absolute inset-0 w-full h-full z-10"
            loading="lazy"
            onLoad={() => {setLoading(false)}}
            style={{
              transition: "opacity 0.5s",
              opacity: loading ? 0 : 1,
            }}
          />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default VerifyCertificate;
